/* eslint-disable no-unused-vars */
/* eslint-disable no-case-declarations */
import defaults from "../defaults";

const SET_USER_SUSPENSION = "user/SET_USER_SUSPENSION";

const initialState = defaults.user;

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {
		case SET_USER_SUSPENSION: {
			return {
				...state,
				suspension: action.suspension,
			};
		}

		default:
			return state;
	}
}

export function setUserSuspension(to, code, id, isBanForNewContent = false) {
	return {
		type: SET_USER_SUSPENSION,
		suspension: {
			duration: Math.floor(to - Date.now() / 1000),
			to,
			code,
			id,
			isBanForNewContent,
		},
	};
}

export function clearUserSuspension() {
	return {
		type: SET_USER_SUSPENSION,
		suspension: {
			duration: 0,
			to: -1,
			code: -1,
		},
	};
}
